import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectResume = (state : GlobalState) => state.managers.resume;

export const managersResumeSelector = createSelector(
    [selectResume],
    data => data
)
